import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import { Modal } from "../../modal";
import { TrackerRelationshipsService } from "../../../services/trackerRelationships";
import { useEffect, useState } from "react";

export const AlarmsModal = ({ open, handleOnClose, vehicleSelected }) => {

    const trackerRelationshipService = new TrackerRelationshipsService();
    const [alarms, setAlarms] = useState([]);
    const [loading, setLoading] = useState(false);

    const columns = [
        {
            field: 'sensorName',
            headerName: 'Sensor',
            width: 180,
            editable: false,
            renderCell: (sensorName) => {
                var ptName = sensorName.value;
                if (sensorName.value === 'Humidity 1')
                    ptName = 'Umidade 1';
                else if (sensorName.value === 'Humidity 2')
                    ptName = 'Umidade 2';
                else if (sensorName.value === 'Internal Temperature 1')
                    ptName = 'Temperatura 1';
                else if (sensorName.value === 'Internal Temperature 2')
                    ptName = 'Temperatura 2';
                else if (sensorName.value === 'Vibration')
                    ptName = 'Vibração';
                return ptName;
            }
        },
        {
            field: 'sensorValue',
            headerName: 'Valor',
            width: 100,
            editable: false
        },
        {
            field: 'sensorMinThreshold',
            headerName: 'Limiar Inferior',
            width: 125,
            editable: false
        },
        {
            field: 'sensorMaxThreshold',
            headerName: 'Limiar Superior',
            width: 125,
            editable: false
        },
        {
            field: 'dtEvent',
            headerName: 'Data',
            width: 180,
            editable: false,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY HH:mm:ss"),
        },
    ];


    const getAlarmsData = () => {
        trackerRelationshipService.getAlarms(vehicleSelected).then(res => {
            setAlarms(res.data);
            setLoading(true);

        }).catch(error => {
            console.error(error);

        });
    }

    useEffect(() => {
        if (!loading) {
            getAlarmsData();
        }

    }, [alarms]);

    return (
        <Modal showBackArrow open={open} onClose={handleOnClose} title='Alarmes Disparados'>

            <div style={{ paddingTop: '20px', height: 450, width: '100%' }}>
                <DataGrid
                    rows={alarms}
                    columns={columns}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    loading={!loading}

                />
            </div>

        </Modal>
    );
}